import { createContext } from 'react';
import {
	TFileId,
	IItemForGetShortInfo,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	ICreateModifierV2,
} from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface ICreateModifierState {
	fileId: TFileId;
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDsSelectedRestaurant: string[];
	nameOfModifier: string;
	description: string;
	externalId: string;
	hasSchedulePriority: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: Nullable<TLanguageIDs>;
	translations: IMenuTranslation[];
	dataForSubmit: Nullable<ICreateModifierV2>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const createModifierInitialState: ICreateModifierState = {
	fileId: null,
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	IDsSelectedRestaurant: [],
	nameOfModifier: '',
	description: '',
	externalId: '',
	hasSchedulePriority: false,
	activationSchedule: '',
	deactivationSchedule: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateModifierContext extends ICreateModifierState {
	setFileId(value: TFileId): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setIDsRestaurant(value: string[]): void;
	changeNameOfModifier(value: string): void;
	changeDescription(value: string): void;
	changeExternalId(value: string): void;
	generateUniqueExternalId(): void;
	toggleHasSchedulePriority(): void;
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	setFetchedTranslations(value: TLanguageIDs[], defaultCustomerLanguage: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	changeDescriptionTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(data: ICreateModifierV2): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	resetFields(): void;
}

export const CreateModifierContext = createContext<ICreateModifierContext>({
	setFileId: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	changeNameOfModifier: () => undefined,
	changeDescription: () => undefined,
	changeExternalId: () => undefined,
	generateUniqueExternalId: () => undefined,
	toggleHasSchedulePriority: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	setFetchedTranslations: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	changeDescriptionTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createModifierInitialState,
});
